export default __webpack_public_path__ + "static/media/Rectangle 18.1fe2bbeb.png";